import { Route, Routes } from 'react-router-dom';
import RootLayout from './components/RootLayout';
import './output.css';
import AboutUs from './pages/Go_Furnish_Me/About_us';
import EstimateListingPage from './pages/Go_Furnish_Me/EstimateListingPage';
import Overview from './pages/Go_Furnish_Me/Overview';

function App() {
    return (
        <RootLayout>
            <Routes>
                <Route path="/" element={<Overview />} />
                
                {/* <Route path="/go-furnish-me" element={<GoFurnishMePage />} />
                <Route path="/campaign-page-details/:id" element={<CampaignPageDetails />} />
                <Route path="/campaign-page" element={<CampaignPage />} />
                <Route path="/login" element={<AuthPage />} /> */}
                <Route path="/overview" element={<Overview />} />
                <Route path="/ai-estimate" element={<EstimateListingPage />} />
                <Route path="/about" element={<AboutUs />} />
            </Routes>
        </RootLayout>
    );
}

export default App;
